// import React, { useEffect, useRef, useState } from "react";
// import styled from "styled-components";

// const NewsContainer = styled.div`
//   position: fixed;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   z-index: 9999;
//   height: 100px;

//   box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.3);
//   display: flex;
//   align-items: center;
//   background: ${({ background }) => background || "black"};
//   color: ${({ textColor }) => textColor || "#fff"};
//   font-family: ${({ fontFamily }) => fontFamily || "Roboto, sans-serif"};
// `;

// const Title = styled.div`
//   background: ${({ logoBackground }) => logoBackground || "#df2020"};
//   color: ${({ logoTextColor }) => logoTextColor || "white"};
//   font-weight: bold;
//   display: flex;
//   align-items: center;
//   height: 100%;
//   ${"" /* padding: ${({ isImage }) => (isImage ? "10px" : "10 24px")}; */}
//   white-space: nowrap;
// `;

// const TickerWrapper = styled.div`
//   overflow: hidden;
//   flex: 1;
//   position: relative;
// `;

// const TickerList = styled.ul`
//   display: inline-flex;
//   list-style: none;
//   margin: 0;
//   padding: 0;
//   white-space: nowrap;

//   ${({ animationTime, distance }) =>
//     animationTime &&
//     distance &&
//     `
//       animation: tickerMove ${animationTime}s linear infinite;
//       @keyframes tickerMove {
//         from {
//           transform: translateX(0);
//         }
//         to {
//           transform: translateX(${distance}px);
//         }
//       }
//     `}
// `;

// const TickerItem = styled.li`
//   white-space: nowrap;
//   padding: 10px 24px;
//   color: inherit;
//   position: relative;
//   font-size: 1.5rem;

//   &::after {
//     content: "";
//     width: 1px;
//     height: 100%;
//     background: #b8b8b8;
//     position: absolute;
//     top: 0;
//     right: 0;
//   }

//   &:last-child::after {
//     display: none;
//   }
// `;

// const RSSComponent = ({
//   data,
//   background,
//   textColor,
//   fontFamily,
//   logoBackground,
//   logoTextColor,
//   logoImage,
// }) => {
//   const wrapperRef = useRef(null);
//   const listRef = useRef(null);

//   const [animationTime, setAnimationTime] = useState(null);
//   const [distance, setDistance] = useState(null);

//   useEffect(() => {
//     if (!wrapperRef.current || !listRef.current) return;

//     const wrapperWidth = wrapperRef.current.offsetWidth;
//     const listWidth = listRef.current.scrollWidth;
//     const speed = 120;
//     const totalDistance = wrapperWidth + listWidth;
//     const timeInSeconds = totalDistance / speed - 20;

//     setDistance(totalDistance);
//     setAnimationTime(timeInSeconds);
//   }, [data]);

//   return (
//     <NewsContainer
//       background={background}
//       textColor={textColor}
//       fontFamily={fontFamily}
//     >
//       <Title
//         logoBackground={logoBackground}
//         logoTextColor={logoTextColor}
//         isImage={!!logoImage}
//       >
//         {logoImage ? (
//           <img
//             src={logoImage}
//             alt="logo"
//             style={{ height: "70%", maxHeight: "70px", margin: "0", padding: "5px" }}
//           />
//         ) : (
//           <div
//             style={{
//               margin: "10px",
//               width: "50px",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center", // ממרכז אנכית
//               alignItems: "center", // ממרכז אופקית
//               textAlign: "center",
//             }}
//           >
//             <div>{data.name || "Breaking News"}</div>
//             <div style={{ fontSize: "1.2em", color: "white" }}>YNET</div>
//           </div>
//         )}
//       </Title>

//       <TickerWrapper ref={wrapperRef}>
//         <TickerList
//           ref={listRef}
//           animationTime={animationTime}
//           distance={distance}
//         >
//           {data.news.map((item) => (
//             <TickerItem key={item._id}>
//               {item.date + " - " + item.title}
//             </TickerItem>
//           ))}
//         </TickerList>
//       </TickerWrapper>
//     </NewsContainer>
//   );
// };

// export default RSSComponent;

import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import styled from "styled-components";

const NewsContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  height: 100px;
  box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  background: ${({ background }) => background || "black"};
  color: ${({ textColor }) => textColor || "#fff"};
  font-family: ${({ fontFamily }) => fontFamily || "Roboto, sans-serif"};
`;

const Title = styled.div`
  background: ${({ logoBackground }) => logoBackground || "#df2020"};
  color: ${({ logoTextColor }) => logoTextColor || "white"};
  font-weight: bold;
  display: flex;
  align-items: center;
  height: 100%;
  white-space: nowrap;
`;

const TickerWrapper = styled.div`
  overflow: hidden;
  flex: 1;
  position: relative;
`;

// 🟢 אופטימיזציה: הוצאת keyframes מה-template literal לחיסכון ב-CPU
const TickerList = styled.ul`
  display: inline-flex;
  list-style: none;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  
  /* 🟢 שימוש ב-transform3d להאצה חומרתית */
  ${({ animationTime, distance }) =>
    animationTime &&
    distance &&
    `
      animation: tickerMove ${animationTime}s linear infinite;
      will-change: transform;
    `}

  @keyframes tickerMove {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(var(--ticker-distance), 0, 0);
    }
  }
`;

const TickerItem = styled.li`
  white-space: nowrap;
  padding: 10px 24px;
  color: inherit;
  position: relative;
  font-size: 1.5rem;

  &::after {
    content: "";
    width: 1px;
    height: 100%;
    background: #b8b8b8;
    position: absolute;
    top: 0;
    right: 0;
  }

  &:last-child::after {
    display: none;
  }
`;

// 🟢 מימוש Logo כ-React.memo למניעת re-renders מיותרים
const LogoSection = React.memo(({ logoImage, logoBackground, logoTextColor, data }) => (
  <Title logoBackground={logoBackground} logoTextColor={logoTextColor}>
    {logoImage ? (
      <img
        src={logoImage}
        alt="logo"
        style={{ 
          height: "70%", 
          maxHeight: "70px", 
          margin: "0", 
          padding: "5px",
          // 🟢 אופטימיזציה לטעינת תמונות
          loading: "lazy",
          decoding: "async"
        }}
      />
    ) : (
      <div
        style={{
          margin: "10px",
          width: "50px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div>{data.name || "Breaking News"}</div>
        <div style={{ fontSize: "1.2em", color: "white" }}>YNET</div>
      </div>
    )}
  </Title>
));

const RSSComponent = ({
  data,
  background,
  textColor,
  fontFamily,
  logoBackground,
  logoTextColor,
  logoImage,
}) => {
  const wrapperRef = useRef(null);
  const listRef = useRef(null);
  const rafRef = useRef(null);

  const [animationTime, setAnimationTime] = useState(null);
  const [distance, setDistance] = useState(null);

  // 🟢 מימוש news items כ-memoized למניעת map מיותר
  const newsItems = useMemo(() => 
    data.news.map((item) => ({
      id: item._id,
      content: item.date + " - " + item.title
    })), [data.news]
  );

  // 🟢 חישוב האנימציה עם useCallback למניעת יצירת פונקציה חדשה בכל render
  const calculateAnimation = useCallback(() => {
    if (!wrapperRef.current || !listRef.current) return;

    // 🟢 שימוש ב-requestAnimationFrame לביצועים טובים יותר
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
    }

    rafRef.current = requestAnimationFrame(() => {
      const wrapperWidth = wrapperRef.current.offsetWidth;
      const listWidth = listRef.current.scrollWidth;
      const speed = 120;
      const totalDistance = wrapperWidth + listWidth;
      const timeInSeconds = totalDistance / speed - 20;

      // 🟢 עדכון CSS variable למניעת re-creation של keyframes
              document.documentElement.style.setProperty('--ticker-distance', `${totalDistance}px`);
      
      setDistance(totalDistance);
      setAnimationTime(timeInSeconds);
    });
  }, []);

  // 🟢 אופטימיזציה: dependency רק על newsItems.length במקום כל data
  useEffect(() => {
    calculateAnimation();
    
    // 🟢 cleanup function
    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, [newsItems.length, calculateAnimation]);

  // 🟢 ResizeObserver יעיל יותר מ-window resize listener
  useEffect(() => {
    if (!wrapperRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      calculateAnimation();
    });

    resizeObserver.observe(wrapperRef.current);
    return () => resizeObserver.disconnect();
  }, [calculateAnimation]);

  return (
    <NewsContainer
      background={background}
      textColor={textColor}
      fontFamily={fontFamily}
    >
      <LogoSection
        logoImage={logoImage}
        logoBackground={logoBackground}
        logoTextColor={logoTextColor}
        data={data}
      />

      <TickerWrapper ref={wrapperRef}>
        <TickerList
          ref={listRef}
          animationTime={animationTime}
          distance={distance}
        >
          {newsItems.map((item) => (
            <TickerItem key={item.id}>
              {item.content}
            </TickerItem>
          ))}
        </TickerList>
      </TickerWrapper>
    </NewsContainer>
  );
};

// 🟢 React.memo למניעת re-renders כאשר props לא השתנו
export default React.memo(RSSComponent);